import React, { useEffect, useState } from "react";

import {
  DELEGATION_MANAGEMENT_STEP_3_FORM_FILTER,
  IDelegationManagementStepThreeProps,
  ROLE_TYPE,
} from "./module/constants";
import { DELEGATION_MANAGEMENT_URLS, EMPLOYEE } from "../module/constants";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";

import { Row } from "react-table";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import { FormattedMessage } from "react-intl";
import ConfirmModal from "../../../components/Modals/ConfirmModal/ConfirmModal";
import ResponseModal from "../../../components/Modals/ResponseModal/ResponseModal";
import {
  IDENTITY_SYSTEM,
  IDENTITY_SYSTEM_LIST,
  IdentitySystemType,
  ROUTES,
} from "../../../module/constants";
import Panel from "../../../ui/Panel/Panel";
import Table from "../../../components/Table/Table";
import FilterTable from "../../../components/FilterTable/FilterTable";
import DoubleDateModal from "../../../components/Modals/DoubleDateModal/DoubleDateModal";

import {
  selectUsers,
  selectCallState,
  selectSelectedUsersDelegation,
  selectSelectedRole,
  selectUsersLoader,
} from "../module/selectors";
import {
  modifySelectedUsersDelegation,
  delegationUserRequest,
  createDelegationRequest,
  delegationUserBAORequest,
} from "../module/actions";
import { selectUserInfo } from "../../../App/module/selectors";

import { push } from "connected-react-router";
import { connect } from "react-redux";
import messages from "./module/messages";
import filterMessages from "../../../translations/filterMessages";
import { createStructuredSelector } from "reselect";
import { isEmpty } from "ramda";

import classes from "./DelegationManagementStepThree.module.scss";
import {
  ISectionType,
  ITableType,
} from "../../../common/TablesConfiguration/tcConstants";
import { selectConsultantDelegationEnabled } from "../../../store/global/selectors";

const TypeFilter = {
  identitySystemIdFilter: "identitySystemId",
  nameFilter: "name",
  surnameFilter: "surname",
  userIdFilter: "code",
  userTypeFilter: "type",
  organizationalUnitFilter: "organizational_unit",
  emailFilter: "email",
  managerFullNameFilter: "resp_full_name",
};

const DelegationManagementStepThree = (
  props: IDelegationManagementStepThreeProps
) => {
  const {
    userInfo,
    users,
    selectedRole,
    selectedUsers,
    usersLoader,
    callState,
    consultantDelegationEnabled,
    delegationUserRequest,
    delegationUserBAORequest,
    modifySelectedUsersDelegation,
    createDelegationRequest,
    changeLocation,
  } = props;

  const [showDateModal, setShowDateModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [startDate, setStartDate] = useState<Date>();
  const [finishDate, setFinishDate] = useState<Date>();
  const [displayedUsers, setDisplayedUser] = useState<any>([]);

  const form = DELEGATION_MANAGEMENT_STEP_3_FORM_FILTER;

  const [filter, setFilter] = useState<any>([]);

  const onSubmit: any = (values: any = {}) => {
    const { advancedSearchFilter, allFilter = "", ...rest } = values;
    let valueFilter: any[] = [];
    if (values && isEmpty(values)) return setFilter([]);
    if (advancedSearchFilter) {
      if (!isEmpty(rest)) {
        Object.keys(rest).forEach((element: any) => {
          valueFilter.push({
            id: TypeFilter[element as keyof typeof TypeFilter],
            value:
              element === "identitySystemIdFilter"
                ? IDENTITY_SYSTEM[rest[element] as keyof typeof IDENTITY_SYSTEM]
                : rest[element],
            operation: "AND",
          });
        });
      }
    } else {
      valueFilter = [
        { id: "code", value: allFilter, operation: "OR" },
        { id: "name", value: allFilter, operation: "OR" },
        { id: "surname", value: allFilter, operation: "OR" },
      ];
    }
    setFilter(valueFilter);
  };

  const checkboxHandler = (checkedElements: Row<object>[]) => {
    let tempCheckedElements: object[] = [];
    checkedElements.map((el) => {
      tempCheckedElements.push(el.original);
    });
    modifySelectedUsersDelegation(tempCheckedElements);
  };

  useEffect(() => {
    if (selectedRole.role === ROLE_TYPE.BAO) {
      delegationUserBAORequest(userInfo.organizational_unit_code);
    } else {
      delegationUserRequest();
    }
  }, []);

  useEffect(() => {
    if (consultantDelegationEnabled) {
      setDisplayedUser(users);
    } else {
      const internalUsers = users.filter((user) => user.type === EMPLOYEE);
      setDisplayedUser(internalUsers);
    }

    return () => setDisplayedUser([]);
  }, [users]);

  const setDate = (startDate1: Date, finishDate1: Date) => {
    setStartDate(startDate1);
    setFinishDate(finishDate1);
    setShowDateModal(false);
    setShowConfirmModal(true);
  };

  const delegateUsers = () => {
    setShowConfirmModal(false);
    setShowResponseModal(true);
    let delegationOBJ = {};
    Object.assign(delegationOBJ, { delegator: userInfo.code });
    let delegatedArray: any[] = [];
    selectedUsers.forEach((user) => {
      delegatedArray.push(user.code);
    });
    Object.assign(delegationOBJ, { delegated: delegatedArray });
    Object.assign(delegationOBJ, { role: selectedRole.role });
    const date = new Date();
    Object.assign(delegationOBJ, {
      beginDate: startDate ? startDate.getTime() : null,
    });
    Object.assign(delegationOBJ, {
      endDate: finishDate ? finishDate.getTime() : null,
    });
    Object.assign(delegationOBJ, { target: selectedRole.target });
    createDelegationRequest(delegationOBJ);
  };

  return (
    <React.Fragment>
      <DoubleDateModal
        show={showDateModal}
        onCloseModal={() => setShowDateModal(false)}
        onConfirm={(startDate: Date, finishDate: Date) =>
          setDate(startDate, finishDate)
        }
      />
      <ConfirmModal
        show={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={() => delegateUsers()}
      />
      <ResponseModal
        show={showResponseModal}
        state={callState}
        onClose={() => changeLocation(ROUTES.DELEGATES)}
      />

      <div className={classes["actionsTop"]}>
        <OutlinedButton
          onClick={() =>
            changeLocation(DELEGATION_MANAGEMENT_URLS.ADD_DELEGATION)
          }
        >
          <FormattedMessage {...messages.backCTA} />
        </OutlinedButton>
        <OutlinedButton
          onClick={() => setShowDateModal(true)}
          disabled={selectedUsers.length === 0}
        >
          <FormattedMessage {...messages.delegaCTA} />
        </OutlinedButton>
      </div>

      <div className={classes["mainTitle"]}>
        <FormattedMessage {...messages.mainTitle} />
      </div>

      <div className={classes["searchUserPanel"]}>
        <Panel
          title={<FormattedMessage {...messages.searchUser} />}
          loader={usersLoader}
        >
          {displayedUsers && displayedUsers.length > 0 ? (
            <>
              <FilterTable
                messages={{ ...filterMessages, ...messages }}
                formProps={form}
                listsFilter={{
                  IDENTITY_SYSTEM_LIST: {
                    list: IDENTITY_SYSTEM_LIST,
                    type: IdentitySystemType,
                  },
                }}
                onSubmitProps={(val: any) => onSubmit(val)}
                advancedFilter={true}
                isAccordion={true}
                sectionType={ISectionType.DELEGATIONS}
                tableType={ITableType.USERS_TABLE}
                typeFilter={TypeFilter}
                simpleFilterFields={["code", "name", "surname"]}
              />
              <Table
                filterProps={filter}
                showChekbox={true}
                dataSource={displayedUsers}
                rowsChangeable={true}
                onCheckboxChangeEvent={true}
                onCheckboxChange={checkboxHandler}
                selectAll={true}
                initialState={{}}
                sectionType={ISectionType.DELEGATIONS}
                tableType={ITableType.USERS_TABLE}
              />
            </>
          ) : (
            <></>
          )}
          {!displayedUsers ||
          (displayedUsers && displayedUsers.length === 0) ? (
            <div className={classes["no-user-found"]}>
              <FormattedMessage {...messages.noUserFound} />
            </div>
          ) : (
            <></>
          )}
        </Panel>
      </div>

      <div className={classes["actions"]}>
        <OutlinedButton
          onClick={() =>
            changeLocation(DELEGATION_MANAGEMENT_URLS.ADD_DELEGATION)
          }
        >
          <FormattedMessage {...messages.backCTA} />
        </OutlinedButton>
        <OutlinedButton
          onClick={() => setShowDateModal(true)}
          disabled={selectedUsers.length === 0}
        >
          <FormattedMessage {...messages.delegaCTA} />
        </OutlinedButton>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    userInfo: selectUserInfo,
    selectedRole: selectSelectedRole,
    selectedUsers: selectSelectedUsersDelegation,
    users: selectUsers,
    usersLoader: selectUsersLoader,
    callState: selectCallState,
    consultantDelegationEnabled: selectConsultantDelegationEnabled,
  });

const mapDispatchToProps: any = {
  delegationUserRequest: () => delegationUserRequest(),
  delegationUserBAORequest: (ou: string) => delegationUserBAORequest(ou),
  modifySelectedUsersDelegation: (selectedUsers: object[]) =>
    modifySelectedUsersDelegation(selectedUsers),
  createDelegationRequest: (delegationOBJ: {}) =>
    createDelegationRequest(delegationOBJ),
  changeLocation: (url: string) => push(url),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(DelegationManagementStepThree);
